import { render } from "./KeywordWatchList.vue?vue&type=template&id=5cc7beda"
import script from "./KeywordWatchList.vue?vue&type=script&lang=js"
export * from "./KeywordWatchList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-portal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__